import { UpgradeToMuseProDialogType, useAppContext } from '@/AppContext'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import ElectronIPC from '@/services/ElectronIPC'
import * as Constants from '@/services/Constants'
import useAnalytics from '@/services/useAnalytics'

export function useUnlockProHandler() {
    const [_appState, appDispatch] = useAppContext()
    const { logUserActivityWithContext } = useAnalytics()

    return (reason?: UpgradeToMuseProDialogType, forceBrowserModal?: boolean) => {
        if (reason) {
            appDispatch({
                type: 'update_app_state',
                value: { showUpgradeToMuseProDialog: { type: reason, forceBrowserModal } },
            })
        } else {
            logUserActivityWithContext(AnalyticsEvents.CLICKED_UPGRADE_BUTTON, {
                upgradeReason: reason ?? 'unspecified',
            })
            ElectronIPC.openLinkInBrowser(Constants.links.muse_pro_plans_link)
        }
    }
}
